import BaseClass from "./BaseClass";

class SharedContacts extends BaseClass {
  get gravatar() {
    return this.email;
  }

  get schema() {
    return {
      name: {
        editable: true
      },
      email: {
        editable: true
      },
      phone: {
        editable: true
      }
    };
  }

  get actions() {
    return {
      unlink_customer: {
        handler: () => Promise.resolve("unlink_customer"),
        props: { type: "danger", size: "small" },
        in_edit_mode: false
      },
      edit: {
        handler: () => Promise.resolve("edit"),
        props: { type: "primary", size: "small" },
        in_edit_mode: false
      },
      save: {
        handler: () => this._handleSave(),
        props: { type: "success", size: "small" },
        in_edit_mode: true
      },
      cancel: {
        handler: () => Promise.resolve("cancel"),
        props: { type: "primary", size: "small" },
        in_edit_mode: true
      }
    };
  }

  _handleSave(show_notice = true) {
    return this._api
      .mutate({
        mutation: require("../../graphql/contacts/contacts_save.graphql"),
        variables: this
      })
      .then(() => {
        /*let errors;
            try {
                errors = res.data.shared_amocrm.errors;
            } catch (e) {
            }
            if (errors) {
                errors.forEach((e, i) => {
                    setTimeout(
                        () =>
                            this._notify.error({
                                title: "Duplicate",
                                message: e
                            }),
                        150 * i
                    );
                });
                return "not saved";
            }*/
        if (show_notice) {
          this._notify.success({
            title: "Success",
            message: "Saved contact"
          });
        }
        return "save";
      });
  }
}

export default SharedContacts;
